import Vue from 'vue';
import './axiosInterceptorFix';
import axios from 'axios';
import * as _ from 'lodash';

let redirecting = false;

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    Vue.$log.debug('axios response error interceptor', error);
    const status = (error.response && error.response.status) || '';
    const _allowedHttpErrors = error.config._allowedHttpErrors;
    if ((!status || status >= 500 || _.includes([401, 403, 404], status)) && !_.includes(_allowedHttpErrors, status)) {
      if (!redirecting) {
        redirecting = true;
        const done = () => {
          redirecting = false;
        };
        // import of router is delayed; otherwise the apiClient is loaded before the interceptors are in place
        import('../router').then(lib => {
          const router = lib.default;
          router.push({ name: 'api-service-error', query: { status: status.toString() || '###' } }, done, done);
        });
      }
      // return;
    }
    return Promise.reject(error);
  }
);
